
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import DictSelect from '../../ui/DictSelect';


const fields = [{
    "text": "会员号",
    "field": "code",
    disabled: true
}, {
    "text": "会员名称",
    "field": "name",
    disabled: true
}, {
    "text": "账户余额",
    "field": "account",
    disabled: true
}, {
    "text": "实际余额",
    "field": "actualAccount",
    disabled: true
}, {
    "text": "赠送余额",
    "field": "giftAccount",
    disabled: true
}, {
    "text": "充值金额（元）",
    "field": "actualAmount",
    number: true,
    rules: [
        { required: true, message: '充值金额不能为空!' },
    ]
}, {
    "text": "赠送方案",
    "field": "giftSchemeDict",
    select: true,
    category: 'GIFT_SCHEME'
}, {
    "text": "赠送金额（元）",
    "field": "giftAmount",
    disabled: true
}, {
    "text": "发票号码",
    "field": "invoiceNumber",
    rules: [
        { max: 16, message: '发票号码不能超过16个字符！' },
    ]
}, {
    "text": "备注",
    "field": "remark",
    "textarea": true,
    rules: [
        { max: 128, message: '备注不能超过128个字符！' },
    ]
}];


class MemberRechargeForm extends Component {

    state = {
        currentDict: null
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let memberCode = this.props.editData.code
            if (memberCode !== undefined && memberCode != null) {
                values["memberCode"] = memberCode;
            }
            http.post({
                url: '/' + this.props.content + '/rechargeAccount',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("充值申请已提交，请等待财务审核！");
                }
            });
        });
    };

    onChangeValue = (field, value) => {
        this.calculateGift(value, this.state.currentDict)
    }

    onChangeSelect = (dict) => {
        const { form } = this.props;
        let actualAmount = form.getFieldValue("actualAmount");
        this.calculateGift(actualAmount, dict);
    }

    //计算赠送的金额
    calculateGift = (value, dict) => {
        let gift = 0;
        if (dict != null && value != null && value > 0) {
            let des = dict["des"];
            if (des != null && des !== "") {
                let scheme = JSON.parse(des);
                let temp = 0;
                for (let num in scheme) {
                    if (parseInt(value) >= parseInt(num) && parseInt(num) > parseInt(temp)) {
                        temp = num;
                        gift = scheme[num];
                    }
                }
            }
        }
        this.setState({ currentDict: dict });
        const { form } = this.props;
        form.setFieldsValue({ "giftAmount": gift });
    }

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: editData[item.field],
                        })(
                            item.select ? <DictSelect category={item.category} onSelect={this.onChangeSelect} />
                                : item.number ? <InputNumber min={0} max={99999999} precision={2} style={{ width: '100%' }} onChange={this.onChangeValue.bind(this, item.field)} />
                                    : item.textarea ? <Input.TextArea />
                                        : <Input disabled={item.disabled === true} />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="会员充值"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 7 }} wrapperCol={{ span: 17 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const MemberRecharge = Form.create()(MemberRechargeForm);

export default MemberRecharge;